import { useMemo } from 'react';
import { usePartnersDialogOptions } from 'src/components/Navbar/use-partners-dialog-options';
import { useSelectedPartner } from 'src/graphql';
import { useGlobalStore } from 'src/store';

/** Whether the user may open the partner switcher: multi-tenancy, with another partner to pick. */
export const useCanSwitchPartner = () => {
  const isMultiTenancyMode = useGlobalStore.use.isMultiTenancyMode();
  const { selectedPartner } = useSelectedPartner();
  const { partnersOptions } = usePartnersDialogOptions({ currentPartner: false });

  return useMemo(
    () =>
      isMultiTenancyMode &&
      partnersOptions.some(
        (option) => option.id !== null && option.id !== selectedPartner?.partnerId,
      ),
    [isMultiTenancyMode, partnersOptions, selectedPartner?.partnerId],
  );
};
